<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Indicação" subTitle="Visualizar" />

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <lead-page :lead="lead" ref="leadForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import LeadPage from '_modules/lead/components/LeadPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/LeadModel';

export default {
  name: 'lead-view',
  components: {
    PageHeader,
    LeadPage,
  },
  computed: {
    lead() {
      const { lead } = this.$store.state.lead;
      if (lead) {
        Events.$emit(_LOAD_MODEL_, lead);
        return lead;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getLead',
    ]),
    getLeadModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getLead(parseInt(this.$route.params.leadId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.leadForm.save();
    },
  },
  mounted() {
    if (this.$route.params.leadId) {
      this.getLeadModel();
    }
  },
};
</script>
